import { Article } from '../../../components';
import { withLayout } from '../../../Layout/Layout';
import { contentRedirect } from '../../../utils/contentRedirect';
import { httpGet } from '../../../utils/httpClient';

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};
export const getStaticProps = async ({ params }) => {
  const articleRes = await httpGet(
    `${process.env.javaApiUrl}/article/${params.id}`
  );
  const recommendationRes = await httpGet(
    `${process.env.javaApiUrl}/recommendation/destinations/articles/${params.id}`
  );

  if (articleRes.status >= 400) {
    return {
      notFound: true,
      revalidate: 60,
    };
  }
  const article = await articleRes.json();
  const redirectResult = contentRedirect(article, params.id, 'destinations', 'articles');
  if (redirectResult) {
    return redirectResult;
  }
  
  const recommendation = await recommendationRes.json();
  return {
    props: {
      article,
      recommendation,
    },
    revalidate: 60,
  };
};

function AirlineArticle({
  article,
  recommendation,
  setLoginDialogState,
  authCompleted,
}) {
  return (
    <Article
      article={article}
      recommendation={recommendation}
      setLoginDialogState={setLoginDialogState}
      authCompleted={authCompleted}
    />
  );
}

export default withLayout(AirlineArticle, false);
